module.exports = __webpack_public_path__ + "static/review3-0651357f6c51bd4e14954020c177a321.jpeg";